export class ExportaModel {

    anios: any[];
    meses: any[];
    empresas: any[];
    oficinas: any[];

    clienteIni: string;
    clienteFin: string;
    fechaIni: string;
    fechaFin: string;
    tipoDocExport: string;
    cargaTipoDocExport: string;

    constructor(obj: any) {
        this.anios = obj.anios || [];
        this.meses = obj.meses || [];
        this.empresas = obj.empresas || []; //["1001","1002"] || [];
        this.oficinas = obj.oficinas || [];
        this.clienteIni = obj.clienteIni;
        this.clienteFin = obj.clienteFin;
        this.fechaIni = obj.fechaIni;
        this.fechaFin = obj.fechaFin;
        this.tipoDocExport = obj.tipoDocExport;
        this.cargaTipoDocExport = obj.cargaTipoDocExport;
    }
}